import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import Tooltip from "../../../../Elements/Tooltip/Tooltip.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import Button from "../../../../Elements/Button/Button.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import Image from "../../../../Elements/Image/Image.tsx";
import LoaderContainer from "../../../../Reusable/LoaderContainer/LoaderContainer.js";
import config from "config";
import ToastHtmlComponent from "../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import EmbedLimitOptionsModal from "../../../../Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import loader from "helpers/loaderUrl.js";
import usePageInit from "hooks/usePageInit.ts";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";

const checkMark = `${config.api.resource}/assets/images/checkmark.svg`;

const ApiSettings = ({ userData, availableAllPages }) => {
  const { getTextByKey, getPageText, getLanguageCulture } = useContent();
  const { setModal } = useModal();
  const [apiAddress, setApiAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [createdCheckbox, setCreatedCheckbox] = useState(false);
  const [uploadingCheckbox, setUploadingCheckbox] = useState(false);
  const [sentCheckbox, setSentCheckbox] = useState(false);
  const [showJSON, setShowJSON] = useState(false);
  const [embedStatuses, setEmbedStatuses] = useState([]);
  const [apiJsonExample, setApiJsonExample] = useState(getPageText().TextBox3);
  const { addToast } = useToasts();
  const [success, setSuccess] = useState(false);
  const { isPageReady } = usePageInit();

  useEffect(() => {
    if (getPageText().TextBox3 && getPageText().TextBox3 !== undefined) {
      //replace "#BaseUrl#" with the actual base url
      setApiJsonExample(
        getPageText().TextBox3.replace("#BaseUrl#", config.baseurl + "/")
      );
    }
  }, [getPageText()]);

  useEffect(() => {
    getEmbedStatusesList();
    if (userData.EmbedDynamicSettings) {
      setApiAddress(userData.EmbedDynamicSettings.EmbedSettingsAPIUrl);
      if (userData.EmbedDynamicSettings.EmbedSettingsAPIStatuses) {
        for (
          let i = 0;
          i < userData.EmbedDynamicSettings.EmbedSettingsAPIStatuses.length;
          i++
        ) {
          const element =
            userData.EmbedDynamicSettings.EmbedSettingsAPIStatuses[i];
          switch (element) {
            case "sent":
              setSentCheckbox(true);
              break;
            case "created":
              setCreatedCheckbox(true);
              break;
            case "uploading":
              setUploadingCheckbox(true);
              break;

            default:
              break;
          }
        }
      }
    }
  }, []);
  const SaveAPISettingsInDB = async () => {
    if (availableAllPages) {
      var statusesList = [];
      if (createdCheckbox) {
        statusesList.push("created");
      }
      if (uploadingCheckbox) {
        statusesList.push("uploading");
      }
      if (sentCheckbox) {
        statusesList.push("sent");
      }
      setLoading(true);
      const body = {
        StatusesList: statusesList,
        EmbedAPIUrl: apiAddress,
      };
      const response = await apiRequest(
        "EmbedDynamics",
        "UpdateAPISettingsReact",
        body,
        "POST"
      );
      if (response.status === "success") {
        if (response.data === 0) {
          setSuccess(true);
          addToast(getTextByKey("api-setting-saved-success"), {
            appearance: "success",
          });
        } else if (response.data === 1) {
          setSuccess(false);
          addToast(getTextByKey("api-invalid-url"), {
            appearance: "error",
          });
        } else if (response.data === 2) {
          setSuccess(false);
          addToast(getTextByKey("api-statuses-required"), {
            appearance: "error",
          });
        } else if (response.data === 3) {
          setSuccess(false);
          addToast(getTextByKey("api-invalid-url-message"), {
            appearance: "error",
          });
        } else {
          setSuccess(false);
          let errText = getTextByKey("api-error");
          errText = errText.replace("#ERRORNUM#", response.data);
          errText = errText.replace("#SYSMAIL#", "contact-us");
          errText = errText.replace("#SYSMAIL#", config.supportmail);
          errText = errText.replace("#SYSMAIL#", "contact-us");
          addToast(<ToastHtmlComponent htmlStr={errText} />, {
            appearance: "error",
          });
        }
      }
      setLoading(false);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const getEmbedStatusesList = async () => {
    setLoading(true);
    const parameters = {
      culture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedSystemStatuses",
      parameters
    );
    if (response.status === "success") {
      let filtered = response.data.filter(function (value, index, arr) {
        return index < 3;
      });
      setEmbedStatuses(filtered);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setApiAddress(e.target.value);
    setSuccess(false);
  };

  if (!isPageReady) {
    return null;
  }

  return (
    embedStatuses.length > 0 && (
      <LoaderContainer isLoading={loading}>
        <div className="api-container">
          <div className="sub-title-for-developers">
            <h3>{getTextByKey("api-title")}</h3>
            {getPageText().TextBox && parse(getPageText().TextBox)}
          </div>
          <div className="form-api-settings">
            <div className="api-address">
              <div className="tooltip-api-address">
                <span className="your-api-address">
                  {getTextByKey("api-address")}
                </span>
                <Tooltip
                  id={"api-address"}
                  tooltipTextKey={"api-address-tooltip"}
                  // hardPositioned
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>

              <input
                type="text"
                className="api-address-input"
                onChange={handleChange}
                value={apiAddress ? apiAddress : ""}
              />
            </div>
            <div className="api-select-status">
              <div className="select-status-div">
                <span className="select-status">
                  {getTextByKey("api-select-status")}
                </span>
              </div>
              <div className="input-status-div">
                <Image
                  alt=""
                  title=""
                  className="input-checkbox"
                  onClick={(e) => {
                    setSuccess(false);
                    setCreatedCheckbox((prev) => !prev);
                  }}
                  name={
                    createdCheckbox ? "checkbox-checked" : "checkbox-unchecked"
                  }
                  ext="svg"
                />
                <span className="input-label">
                  {embedStatuses[0].Status} (
                  {embedStatuses[0].SystemStatus.toUpperCase()})
                </span>{" "}
                <Tooltip
                  id={"created"}
                  tooltipTextKey={embedStatuses[0].StatusText}
                  // hardPositioned
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>
              <div className="input-status-div">
                <Image
                  alt=""
                  title=""
                  className="input-checkbox"
                  onClick={(e) => {
                    setSuccess(false);
                    setUploadingCheckbox((prev) => !prev);
                  }}
                  name={
                    uploadingCheckbox
                      ? "checkbox-checked"
                      : "checkbox-unchecked"
                  }
                  ext="svg"
                />
                <span className="input-label">
                  {embedStatuses[1].Status} (
                  {embedStatuses[1].SystemStatus.toUpperCase()})
                </span>{" "}
                <Tooltip
                  id={"uploading"}
                  tooltipTextKey={embedStatuses[1].StatusText}
                  // hardPositioned
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>
              <div className="input-status-div">
                <Image
                  className="input-checkbox"
                  onClick={(e) => {
                    setSuccess(false);
                    setSentCheckbox((prev) => !prev);
                  }}
                  name={
                    sentCheckbox ? "checkbox-checked" : "checkbox-unchecked"
                  }
                  ext="svg"
                />
                <span className="input-label">
                  {embedStatuses[2].Status} (
                  {embedStatuses[2].SystemStatus.toUpperCase()}){" "}
                </span>{" "}
                <Tooltip
                  id={"sent"}
                  tooltipTextKey={embedStatuses[2].StatusText}
                  //hardPositioned
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>
            </div>
            <Button
              onClick={() => {
                SaveAPISettingsInDB();
              }}
              disabled={loading || success}
              img={{
                src: loading ? loader : success ? checkMark : null,
                title: loading ? "loader" : success ? "checkmark" : null,
              }}
            >
              {getTextByKey("api-save")}
            </Button>
          </div>
          <div className="json-structure">
            <div className="json-parameters">
              {getPageText().TextBox2 && parse(getPageText().TextBox2)}
            </div>
            <span
              onClick={() => {
                setShowJSON((prev) => !prev);
              }}
              className="json-title"
            >
              {parse(getTextByKey("api-example-link"))}
            </span>
            <div className={`json-example ${!showJSON ? "json-hide" : ""}`}>
              {apiJsonExample && parse(apiJsonExample)}
            </div>
          </div>
        </div>
      </LoaderContainer>
    )
  );
};

export default ApiSettings;
